var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoPausedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.9839,
    cy: 12,
    r: 11.25,
    fill: "#FEFEFF",
    stroke: "#FF6019",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.9839,
    cy: 12,
    r: 11.25,
    fill: "#FEFEFF",
    stroke: "#FF6019",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5327 8.96488C10.8668 8.54567 10 9.02427 10 9.81116V15.2027C10 15.9866 10.8611 16.4657 11.5272 16.0524L15.8404 13.3761C16.4684 12.9865 16.4713 12.0738 15.8459 11.6801L11.5327 8.96488Z",
    fill: "#FF6019"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPausedIcon);
export default __webpack_public_path__ + "static/media/videoPausedIcon.203d7ba4.svg";
export { ForwardRef as ReactComponent };